// The design system's Avatar part (parts/Avatar): a plate square with the
// person's initials, or their photo. X-67 (audit round 4): one initials rule for
// every screen, so the same person never shows "TE" on one and "TA" on another.
// Decoration only: the name is always written beside it. The design system
// asks for no colour per person, so two people with the same initials look
// alike; their names tell them apart.

const TITLES = /^(dr|mr|mrs|ms|prof|h\.?e\.?)\.?$/i;

/**
 * "Dr. Lena Varga" -> "LV", "Milica Jovanović" -> "MJ", "Ana" -> "A": the first letters of the first and
 * the last word; titles and words that do not start with a letter ("[TEST]", "(KE)") are skipped.
 */
export function initials(name: string): string {
  const words = name
    .trim()
    .split(/\s+/)
    .filter((w) => w && !TITLES.test(w) && /^\p{L}/u.test(w));
  if (words.length === 0) return "?";
  const first = words[0][0] ?? "";
  const last = words.length > 1 ? (words[words.length - 1][0] ?? "") : "";
  return (first + last).toUpperCase();
}

/** `size` "s": 32px (top bar, lists); `me`: the person using the app. */
export function Avatar({ name, photoUrl, size, me }: { name: string; photoUrl?: string | null; size?: "s"; me?: boolean }) {
  const cls = ["avatar", size === "s" ? "avatar--s" : null, me ? "avatar--me" : null].filter(Boolean).join(" ");
  if (photoUrl) return <img className={cls} src={photoUrl} alt="" />;
  return (
    <span className={cls} aria-hidden="true">
      {initials(name)}
    </span>
  );
}
